
import Vue from 'vue'
import locale from 'element-ui/lib/locale';
import VueI18n from 'vue-i18n'
import messages from './langs'
import LangEn from './langs/en'
import LangCn from './langs/cn'
import LangTw from './langs/tw'
import LangJa from './langs/ja'
import LangKo from './langs/ko'
import elementEnLocale from 'element-ui/lib/locale/lang/en' // element-ui lang
import elementZhLocale from 'element-ui/lib/locale/lang/zh-CN' // element-ui lang
import elementTwLocale from 'element-ui/lib/locale/lang/zh-TW' // element-ui lang
import elementJaLocale from 'element-ui/lib/locale/lang/ja' // element-ui lang
import elementKoLocale from 'element-ui/lib/locale/lang/ko' // element-ui lang
Vue.use(VueI18n);
//从localStorage获取语言选择。
const i18n = new VueI18n({
    locale: localStorage.getItem('Language')?localStorage.getItem('Language'):"tw" ,
    messages:{
      'cn': {
	    ...LangCn,
	    ...elementZhLocale
	  },
	  'en': {
	    ...LangEn,
	    ...elementEnLocale
	  },
	  'tw': {
	    ...LangTw,
	    ...elementTwLocale
	  },
	  'ja': {
	    ...LangJa,
	    ...elementJaLocale
	  },
	  'ko': {
	    ...LangKo,
	    ...elementKoLocale
	  }
	}
//  silentTranslationWarn: true
})

//i18n: (key, value) => i18n.t(key, value)
 
export default i18n


// WEBPACK FOOTER //
// ./src/i18n/i18n.js